export const getRole = (roles) => {
    if (roles.includes("http://purl.imsglobal.org/vocab/lis/v2/membership#Instructor")) {
        return "teacher"
    } else {
        return "student"
    }
}
